// SPDX-License-Identifier: AGPL-3.0-or-later

import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import {initializeStore} from '@app/features/platform/utils/StoreInitialization';
import {makeAutoObservable} from 'mobx';

// Per device, like GameMode: a member turns server wallpapers off here; only the colour stays.
class GuildWallpapersState {
	enabled = true;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void initializeStore(this, () => makePersistent(this, 'GuildWallpapers', ['enabled']));
	}

	setEnabled(enabled: boolean): void {
		this.enabled = enabled;
	}
}

export default new GuildWallpapersState();
